module.exports = __webpack_public_path__ + "media/images/athletes/1343-28b2ada665b4712197703b425a4603a3.png";